var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"small":_vm.small,"type":"button"},on:{"click":_vm.onexport}},[_vm._v("Excel download")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578e2b4c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!/Volumes/DEVEL/TBAV-actual/tbav/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artworks/ExcelPackings.vue
// module id = xhyk
// module chunks = 0